import { useEffect } from 'react';
import { useNavigationManager } from '@Router/useNavigationManager';
import { RoutesMap } from '@Router/router.types';
import { DnbEmbeddedIntroAnalyticsService } from './DnbEmbeddedIntroAnalytics.service';

export const useDnbEmbeddedIntroLogic = () => {
  const { navigateToNextPage } = useNavigationManager();

  useEffect(() => {
    DnbEmbeddedIntroAnalyticsService.trackPageView();
  }, []);

  const handleGetStarted = () => {
    DnbEmbeddedIntroAnalyticsService.trackGetStartedClick();
    navigateToNextPage(RoutesMap.DNB_EMBEDDED_INTRO);
  };

  return { handleGetStarted };
};
